import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=ea3bacb4&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserCard.vue?vue&type=style&index=1&id=ea3bacb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3bacb4",
  null
  
)

export default component.exports